<!-- prettier-ignore -->
@if(datasource){

<div class="routes-wrapper">

  <h3 (click)="goToSubCategoriesList('events')">
      <span>{{'Eventos' | translate}} >> </span>
  </h3>
    
  <div class="cardsScrollContainer events-scroll-wrapper">
      <img draggable="false" src="/assets/imgs/newArrow.svg" class="route-arrow-left eventGoLeft" alt="{{'Desplazamiento hacia la izquierda' | translate}}" scrollControl />
      <img draggable="false" src="/assets/imgs/newArrow.svg" class="route-arrow-right eventGoRight" alt="{{'Desplazamiento hacia la derecha' | translate}}" scrollControl />

      <!-- <div class="cards-events-container eventContainer">
        @for(item of events; track $index) {
          <div class="event-item">
            <cicerone-generic-card [item]="item"></cicerone-generic-card>
          </div>
        } 
      </div> -->

        <div class="viewport horizontal eventContainer" scrollControl>
          <div *uiScroll="let dsItem of datasource">
              <div class="item horizontal">
                  @if(dsItem.type === 'item'){
                    <cicerone-generic-card 
                      [item]="dsItem.data" 
                      [defaultFileImgName]="getDefaultImgFileName(dsItem.data.id)"
                    />
                  }
                  @if(dsItem.type === 'more'){
                    <cicerone-generic-card 
                      (click)="goToSubCategoriesList('events')" 
                      [defaultFileImgName]="getDefaultImgFileName(dsItem.data.id)"
                      [seeMore]="true" 
                    />
                  }
              </div>
          </div>
          <!-- @if(showMoreButton){
          <div class="item horizontal">
            <cicerone-generic-card (click)="goToSubCategoriesList('events')" [seeMore]="true" />
          </div>
          } -->

        </div>

  </div>

</div>
}